import {
  REQUIRED_FIELD_MESSAGE,
  NOT_VALID_FIELD_MESSAGE
} from "constants/errorMessages";
import { EMAIL_REGEX } from "constants/regexes";
import * as yup from "yup";

export const LoginSchema = yup.object({
  email: yup
    .string()
    .required(REQUIRED_FIELD_MESSAGE())
    .matches(EMAIL_REGEX, NOT_VALID_FIELD_MESSAGE("email")),
  password: yup.string().required(REQUIRED_FIELD_MESSAGE())
});
